<template>
    <div class="features" v-if="active">

        <div class="timeslot text-right">

            <button-checkbox :value="marked"
                button-classes="mark btn-outline-warning btn-icon-only rounded-circle mr-2"
                @change="markTimeslot"
            >
                <span class="btn-inner--icon"><i class="fas fa-map-marker-alt"></i></span>
            </button-checkbox>

            <base-button type="primary" outline
                class="btn-icon-only rounded-circle mr-2"
                @click="createPicture"
            >
                <span class="btn-inner--icon"><i class="fas fa-image"></i></span>
                <span class="badge badge-md badge-circle badge-floating badge-warning no-border"
                        v-if="stats && stats.timeslots[timeslot.id] && stats.timeslots[timeslot.id].pictures">
                    {{ stats.timeslots[timeslot.id].pictures }}
                </span>
            </base-button>

            <base-button type="primary" outline
                class="btn-icon-only rounded-circle mr-2"
                @click="createNote"
            >
                <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                <span class="badge badge-md badge-circle badge-floating badge-warning no-border"
                        v-if="stats && stats.timeslots[timeslot.id] && stats.timeslots[timeslot.id].notes">
                    {{ stats.timeslots[timeslot.id].notes }}
                </span>
            </base-button>

            <base-button type="primary" outline
                class="btn-icon-only rounded-circle mr-4"
                @click="createIssue"
                v-if="!simulation.remedial"
            >
                <span class="btn-inner--icon"><i class="fas fa-exclamation"></i></span>
                <span class="badge badge-md badge-circle badge-floating badge-warning no-border"
                        v-if="stats && stats.timeslots[timeslot.id] && stats.timeslots[timeslot.id].issues">
                    {{ stats.timeslots[timeslot.id].issues }}
                </span>
            </base-button>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            stats: {
                type: Object,
                default: null
            },

            timeslot: {
                type: Object,
                required: true
            },
        },

        data() {
            const feedbackEndpoint = this.session
                ? '/astral/api/front/dashboard/sessions/' + this.session.id + '/feedbacks'
                : '/astral/api/front/dashboard/registrations/' + this.registration.id + '/simulations/' + this.simulation.id + '/feedbacks'

            return {
                feedbackEndpoint,
            }
        },

        computed: {

            active() {
                return this.$permissions.hasRight('dashboard.pilot-log.access')
                    || (this.session && this.session.started_at && !this.session.closed_at)
            },

            marked() {
                return this.stats !== null && this.stats.timeslots[this.timeslot.id] !== undefined && this.stats.timeslots[this.timeslot.id].mark > 0
            },
        },

        methods: {
            
            refresh() {
                this.$emit('refresh')
            },

            markTimeslot(value) {
                // A timeslot may be missing in the stats.
                if (!this.stats.timeslots[this.timeslot.id]) {
                    this.stats.timeslots[this.timeslot.id] = { pictures: 0, notes: 0, issues: 0, mark: 0}
                }
                if (value) {
                    axios.post(this.feedbackEndpoint, {
                        type: 'mark',
                        personal: true,
                        registration_id: this.registration.id,
                        simulation_id: this.simulation.id,
                        session_id: this.session ? this.session.id : null,
                        timeslot_id: this.timeslot.id,
                    })
                    .then(resp => {
                        this.refresh()
                    })
                    .catch(err => {
                        this.$auth.handleErrorVm(err, this)
                    })        

                    // The mark prop takes the mark ID. Assign a temporary one.
                    this.stats.timeslots[this.timeslot.id].mark = 999999999
                } else {
                    const markId = this.stats.timeslots[this.timeslot.id].mark
                    axios.delete(this.feedbackEndpoint + '/' + markId)
                    .then(resp => {
                        this.refresh()
                    })
                    .catch(err => {
                        if (err.response.status == 404) {
                            // This may happen with very closed interactions, do nothing
                            return
                        }
                        this.$auth.handleErrorVm(err, this)
                    })        
                    // The mark prop takes the mark ID. Remove it.
                    this.stats.timeslots[this.timeslot.id].mark = 0
                }
            },

            createNote() {
                this.$emit('createNote', this.timeslot)
            },

            createPicture() {
                this.$emit('createPicture', this.timeslot)
            },

            createIssue() {
                this.$emit('createIssue', this.timeslot)
            },
        }
    }
</script>

<style scoped>

    .features .timeslot >>> button {
        z-index: 1000;
        background-color: white;
    }
    .features .timeslot >>> button:hover {
        z-index: 1000;
        background-color: #5e72e4;
    }
    .features .timeslot >>> button .badge {
        border: none;
        width: 1.4rem;
        height: 1.4rem;
    }
    .features .timeslot >>> .btn-group-toggle {
        display: inline-block;
    }
    .features .timeslot >>> .btn-group-toggle label {
        z-index: 1000;
        background-color: white;
        color: #5e72e4 !important;
        border: 1px solid #5e72e4;
        border-radius: 50% !important;
    }
    .features .timeslot >>> .btn-group-toggle label.active {
        background-color: #fb6340;
        border-color: #fb6340;
        color: white !important;
    }
    .features .timeslot >>> .btn-group-toggle label i {
        padding-top: 12px;
    }
    .no-border {
        border-width: 0
    }

</style>
